import BPDropdownWithAccountsAndAPI from '@molecules/BPDropdownWithAccountsAndAPI';
import React from 'react';

const BPDropdownWithAccounts: React.FC<any> = props => {
  const { productConfig } = props;
  const { accountInput } = productConfig;
  const { fetchAccounts } = accountInput;

  if (fetchAccounts) {
    return <BPDropdownWithAccountsAndAPI {...props} />;
  }

  return null;
};

export default React.memo(BPDropdownWithAccounts);
